import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Alert } from '@cmsgov/ds-medicare-gov'
import { ContentLayout } from 'components/Layouts'
import { MySpinner } from 'components/MySpinner/MySpinner'
import { ConnectedAppsPageContent } from './ConnectedAppsPageContent'
import { BreadCrumb } from 'components/BreadCrumb/BreadCrumb'
import { useGetConnectedApps } from 'queries/connectedApps'
import { MyLink } from 'components/MyLink'
import { useMedicareUrl } from 'hooks/useMedicareUrl'
import { useEvent } from 'hooks/useEvent'

export const ConnectedAppsPage: FC = () => {
  const { t } = useTranslation('connectedApps')
  const { data, isLoading, isError } = useGetConnectedApps()
  const browseAndAddAppsHref = useMedicareUrl(
    'https://www.medicare.gov/manage-your-health/medicares-blue-button-blue-button-20/blue-button-apps',
    'https://es.medicare.gov/manage-your-health/medicares-blue-button-blue-button-20/blue-button-apps?Lang=es'
  )
  const { fireEvent } = useEvent('connectedApps')

  return (
    <>
      <BreadCrumb
        backButtonText={t('breadcrumbs.back')}
        width='wide'
        navAriaLabel={t('breadcrumb.back')}
        backButtonLink='/account-settings'
        onClick={(params) => {
          fireEvent('accountsettings_connectedappsbacktoaccountsettings_click', params)
        }}
      />
      <ContentLayout
        className='ds-u-padding-bottom--7'
        heading={t('connectedApps.heading')}
        width='wide'
        withPrintButton
        description={!isLoading && !isError && (
          <div className='ds-u-padding--1 ds-l-lg-col--9'>
            {t('appsPermissions1')}
            <MyLink
              className='ds-u-color--secondary ds-u-text-decoration--underline'
              href={browseAndAddAppsHref}
              onClick={(params) => {
                fireEvent('accountsettings_connectedappsbrowseapps_click', params)
              }}
            >
                {t('appsPermissions2')}
            </MyLink>.
          </div>
        )}
      >
        <div className='ds-l-container'>
          <div className='ds-l-row'>
            <div className='ds-l-col--12'>
              {(isLoading && !isError) && (
                <MySpinner />
              )}
              {(!isLoading && !isError) && (
                <ConnectedAppsPageContent apps={data?.apps || []}/>
              )}
              {isError && (
                <Alert variation='warn' role='alert' hideIcon={true}>
                  <p className='ds-c-alert__text'>{t('errorMessage')}</p>
                </Alert>
              )}
            </div>
          </div>
        </div>
      </ContentLayout>
    </>
  )
}
